// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import {
  FormValues, RepeatableValue, Feature, Record,
} from '@fulcrumapp/fulcrum-core';
import RepeatableListItemView from './repeatable-list-item-view';

export default class RepeatableListView extends React.Component {
  static propTypes = {
    editing: PropTypes.bool.isRequired,
    onRepeatableItemOpen: PropTypes.func.isRequired,
    onRepeatableItemRemove: PropTypes.func.isRequired,
    onRepeatableItemHighlight: PropTypes.func.isRequired,
    highlightedFeature: PropTypes.instanceOf(Feature),
    mapVisible: PropTypes.bool.isRequired,
    parentValues: PropTypes.instanceOf(FormValues).isRequired,
    parentGeometry: PropTypes.object,
    feature: PropTypes.instanceOf(Feature).isRequired,
    record: PropTypes.instanceOf(Record).isRequired,
    repeatableValue: PropTypes.instanceOf(RepeatableValue).isRequired,
    levelId: PropTypes.string,
    statusColor: PropTypes.string,
    fetchNearbyRecords: PropTypes.func.isRequired,
  };

  // for media queries
  constructor(props, context) {
    super(props, context);

    this.state = {
      matchesMd: window.matchMedia('(max-width: 1400px)').matches,
      matchesSm: window.matchMedia('(max-width: 960px)').matches,
    };
  }

  componentDidMount() {
    const handlerMd = (e) => this.setState({ matchesMd: e.matches });
    window.matchMedia('(max-width: 1400px)').addEventListener('change', handlerMd);

    const handlerSm = (e) => this.setState({ matchesSm: e.matches });
    window.matchMedia('(max-width: 960px)').addEventListener('change', handlerSm);
  }

  componentWillUnmount() {
    window.matchMedia('(max-width: 1400px)').removeEventListener('change', this.handlerMd);
    window.matchMedia('(max-width: 960px)').removeEventListener('change', this.handlerSm);
  }
  // END for media queries

  render() {
    const { mapVisible } = this.props;

    const { styles } = RepeatableListView;

    // styling for media queries
    const containerStyle = {
      width: (() => {
        switch (true) {
          case mapVisible && this.state.matchesSm:
            return 700;
          case mapVisible && this.state.matchesMd:
            return 560;
          case mapVisible:
            return 700;
          default:
            return '100%';
        }
      })(),
    };

    return (
      <div className={styles.container} style={containerStyle}>
        <div className={styles.itemsContainer}>
          {this.renderEmptyList()}
          {this.renderItems()}
        </div>
      </div>
    );
  }

  renderEmptyList() {
    if (this.props.repeatableValue.isEmpty) {
      const { styles } = RepeatableListView;

      return (
        <div className={styles.empty}>
          <div className={styles.emptyLine}>There are currently no items.</div>
          <div className={styles.emptyLine}>Click the (+) button to create a new item.</div>
        </div>
      );
    }

    return null;
  }

  renderItems() {
    return this.props.repeatableValue.mapItems((item) => {
      const { highlightedFeature } = this.props;
      const highlighted = item?._id === highlightedFeature?._id;
      return (
        <RepeatableListItemView
          item={item}
          key={item.id}
          editing={this.props.editing}
          onClick={this.handleItemClick}
          onDelete={this.handleDeleteClick}
          onMouseEnter={this.handleListItemMouseEnter}
          onMouseLeave={this.handleListItemMouseLeave}
          highlighted={highlighted}
        />
      );
    });
  }

  handleDeleteClick = (item) => {
    this.props.repeatableValue.removeItem(item.id);

    this.props.onRepeatableItemRemove(this.props.repeatableValue);
  };

  handleItemClick = (item) => {
    this.openItem(item);
  };

  openItem(item) {
    this.props.onRepeatableItemOpen(item, this.props.parentValues);
  }

  handleListItemMouseEnter = (item) => {
    this.props.onRepeatableItemHighlight(item);
  };

  handleListItemMouseLeave = (item) => {
    this.props.onRepeatableItemHighlight(null);
  };

  handleMapFeatureSelect = (item) => {
    this.openItem(item);
  };

  get shouldMapBeVisible() {
    return this.props.repeatableValue.element.isGeometryEnabled && this.props.mapVisible;
  }
}

const styles = cssInJS({
  container: {
    transition: 'all 80ms ease',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: 700,
    backgroundColor: '#fff',
    fontFamily: THEME.fontFamily,
  },

  itemsContainer: {
    flex: 1,
    minWidth: 560,
    overflow: 'auto',
    transition: 'all 80ms ease',
    backgroundColor: '#fff',
    boxShadow: '0px -4px 50px 3px rgba(0,0,0,0.2)',
    zIndex: 1,
  },

  empty: {
    padding: 50,
    textAlign: 'center',
  },

  emptyLine: {
    marginBottom: 30,
  },

  mapContainer: {
    flex: 0.5,
    transition: 'all 80ms ease',
  },

  map: {
    height: '100%',
  },
});

RepeatableListView.styles = styles;
